import http from "@/utils/http";


export const MessagePushConfigurationApi = {

    getMessagePushConfigurationByCurrentCompany() {
        return http.get(`/server/messagePushConfiguration/getMessagePushConfigurationByCurrentCompany`)
    },
    updateMessagePushConfiguration(data) {
        return http.post(`/server/messagePushConfiguration/updateMessagePushConfiguration`,data)
    },
}